import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ICON_NAMES } from '../../core/constants/app.constant';


@Injectable({ providedIn: 'root' })
export class IconService {
  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly cache = new Map<string, SafeHtml>();

  preload(): Promise<void> {
    return Promise.all(
      ICON_NAMES.map(async (name) => {
        const svg = await firstValueFrom(
          this.http.get(`/assets/icons/${name}.svg`, { responseType: 'text' }),
        );
        this.cache.set(name, this.sanitizer.bypassSecurityTrustHtml(svg));
      }),
    ).then(() => undefined);
  }

  icon(name: string): SafeHtml {
    return this.cache.get(name) ?? this.sanitizer.bypassSecurityTrustHtml('');
  }
}
